import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  resultsWrapper: {
    marginTop: theme.spacing(3),
    padding: 0,
  },
  headerCard: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(4),
  },
  caseTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: '1.25rem',
    letterSpacing: '0.5px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
  },
  caseSubtitle: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    marginTop: theme.spacing(1.5),
    fontSize: '0.875rem',
    lineHeight: '1.6',
    textAlign: 'justify',
  },
  metaGrid: {
    marginTop: theme.spacing(1),
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: '12px',
    backgroundColor: theme.palette.type === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(10, 37, 64, 0.025)',
    border: theme.palette.type === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.06)'
      : '1px solid rgba(10, 37, 64, 0.05)',
    transition: 'all 0.2s ease',
    height: '100%',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.06)'
        : 'rgba(10, 37, 64, 0.05)',
      boxShadow: theme.shadows[1],
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(10, 37, 64, 0.1)',
    },
  },
  metaIcon: {
    color: theme.palette.icon,
    fontSize: '1.5rem',
    marginRight: theme.spacing(1),
  },
  metaTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  metaLabel: {
    fontSize: '0.65rem',
    fontWeight: 700,
    letterSpacing: '1px',
    color: theme.palette.text.secondary,
  },
  metaValue: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  item: {
    padding: theme.spacing(1, 2),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  listaExaminadores: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  listaExaminadoresItem: {
    paddingTop: '3px',
  },
  tableHeader: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#E4E6E8',
  },
  tableRow: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#f4f6f8',
    width: '100%',
    cursor: 'pointer',
  },
  card: {
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    borderRadius: '8px',
    backgroundColor: theme.palette.background.paper,
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
    },
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  cardContent: {
    padding: theme.spacing(2),
  },
}))
